import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=4904ac26&scoped=true&"
import script from "./uploader.vue?vue&type=script&lang=js&"
export * from "./uploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904ac26",
  null
  
)

export default component.exports